'use client'
import BlogItem from "@/components/blog/BlogItems"
import { containerBreakpoints } from "@/components/breakpoints"
import { Box, Container, Select, Spacer } from "@chakra-ui/react"
import { useRouter } from "next/navigation"
import ConteudoTitleBlog from "./ConteudoTitleBlog";
import BlogCategoriesList from "./BlogCategoriesList"
import Pagination from "@/components/Pagination"


const Blog = (props: any) => {


    const { data, config, news = [], pagination, categories = [], tags = [], } = props
    const router = useRouter()

    const getTagsName = () => {
        if (!data) return ''
        data?.Tags?.data.map((tag: any) => tag?.attributes?.Nome).join(', ')
    }

    const getClassName = () => !data ? '' : data?.ClassName

    const onSelectTag = (tag: string) => {
        router.push(`?tag=${tag}`)
    }
    const onSelectCategory = (category: string) => {
        router.push(`?category=${category}`)
    }

    return (
        <Box as="section" className="lista-blog">
            <Container maxW={containerBreakpoints}>
                <Box mt={'80px'} className="div-tit-header">
                    <ConteudoTitleBlog data={{ ...config?.data?.attributes?.BlogPosts, Alinhamento: 'Centro' }} />
                </Box>
                <Box w={'full'} display={'flex'} alignItems={'center'} p={4} flexDirection={{base: 'column', sm: 'column', md:'row', }} gap={2}>
                    <Box textAlign={'end'} pe={2} flex={1}>
                        Mostrando {pagination?.page}-{pagination?.pageCount} de {pagination?.total}
                    </Box>
                    <Box w={{base: '100%', sm: '100%', md:'15%'}} display={'flex'}>
                        <Select placeholder="Tags" onChange={(event) => onSelectTag(event.target.value)} variant={'filled'} size='sm'>
                            {tags.map((tag: any) => {
                                return <option value={tag?.attributes?.Slug} key={tag.id}>{tag?.attributes?.Nome}</option>
                            })}
                        </Select>
                    </Box>
                    <Box w={{base: '100%', sm: '100%', md:'15%'}} display={'flex'} >

                        <Select placeholder="Categorias" onChange={(event) => onSelectCategory(event.target.value)} variant={'filled'} size='sm'>
                            {categories.map((category: any) => {
                                return <option value={category?.attributes?.Slug} key={category.id}>{category?.attributes?.Nome}</option>
                            })}
                        </Select>
                    </Box>
                </Box>
                <Box w={'100%'} display={'flex'}>
                    <Box w={{ sm: '100%', md: '75%' }} display={'flex'} p={{base:0, sm:0, md:4}} flexDirection={'column'}>
                        <Box w={'100%'} display={'flex'} flexWrap={'wrap'}>
                            {news.map((item: any, index: number) => {
                                return <BlogItem
                                    textoLink="Leia Mais"
                                    key={`blog-item-${index}`}
                                    width={{ lg: '50%', md: '50%', base: '100%' }}
                                    item={item} />
                            })}
                            {!news.length && <>Sem atualizações recentes para tag(s) {getTagsName()}</>}
                        </Box>
                        <Box w={'100%'} mt={4} px={4} pb={4}>
                            <Pagination
                                totalCount={pagination?.total}
                                pageSize={pagination?.pageSize}
                                currentPage={pagination?.page} />
                        </Box>

                    </Box>
                    <Box w={'25%'} p={4} display={{ base: 'none', sm: 'none', md: 'block' }}>
                        <BlogCategoriesList categories={categories} />
                    </Box>
                </Box>

            </Container>
        </Box>
    )

}

export default Blog